/**
 * @flow
 * @relayHash b15e40bd1e4f7336c75156dd7fe8d7ce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type initialValuesQueryQueryVariables = {|
  name?: ?string,
  first?: ?number,
  appName?: ?string,
|};
export type initialValuesQueryQueryResponse = {|
  +authorizedOrgs: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +suborgs: $ReadOnlyArray<{|
      +id: string,
      +name: string,
      +region: ?string,
      +timezone: ?string,
      +timezoneOffset: ?string,
      +timezoneAbbr: ?string,
      +propertyLogoUrl: ?string,
      +propertyManagerLogoUrl: ?string,
      +linkColor: ?string,
      +fontFamily: ?string,
      +textColor: ?string,
      +buttonBorderColor: ?string,
      +buttonFontColor: ?string,
      +buttonBackgroundColor: ?string,
    |}>,
  |}>
|};
export type initialValuesQueryQuery = {|
  variables: initialValuesQueryQueryVariables,
  response: initialValuesQueryQueryResponse,
|};
*/


/*
query initialValuesQueryQuery(
  $name: String
  $first: Int
  $appName: String
) {
  authorizedOrgs(name: $name, first: $first, appName: $appName) {
    id
    name
    suborgs {
      id
      name
      region
      timezone
      timezoneOffset
      timezoneAbbr
      propertyLogoUrl
      propertyManagerLogoUrl
      linkColor
      fontFamily
      textColor
      buttonBorderColor
      buttonFontColor
      buttonBackgroundColor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function () {
  var v0 = [
    {
      "kind": "LocalArgument",
      "name": "name",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "appName",
      "type": "String",
      "defaultValue": null
    }
  ],
    v1 = {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    v2 = {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    v3 = [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedOrgs",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "appName",
            "variableName": "appName"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "concreteType": "Org",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "suborgs",
            "storageKey": null,
            "args": null,
            "concreteType": "Suborg",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "region",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "timezone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "timezoneOffset",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "timezoneAbbr",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyLogoUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyManagerLogoUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "linkColor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fontFamily",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "textColor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "buttonBorderColor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "buttonFontColor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "buttonBackgroundColor",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ];
  return {
    "kind": "Request",
    "fragment": {
      "kind": "Fragment",
      "name": "initialValuesQueryQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": (v0/*: any*/),
      "selections": (v3/*: any*/)
    },
    "operation": {
      "kind": "Operation",
      "name": "initialValuesQueryQuery",
      "argumentDefinitions": (v0/*: any*/),
      "selections": (v3/*: any*/)
    },
    "params": {
      "operationKind": "query",
      "name": "initialValuesQueryQuery",
      "id": null,
      "text": "query initialValuesQueryQuery(\n  $name: String\n  $first: Int\n  $appName: String\n) {\n  authorizedOrgs(name: $name, first: $first, appName: $appName) {\n    id\n    name\n    suborgs {\n      id\n      name\n      region\n      timezone\n      timezoneOffset\n      timezoneAbbr\n      propertyLogoUrl\n      propertyManagerLogoUrl\n      linkColor\n      fontFamily\n      textColor\n      buttonBorderColor\n      buttonFontColor\n      buttonBackgroundColor\n    }\n  }\n}\n",
      "metadata": {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '646f24b81a290d24951b2c52ee5204b5';
module.exports = node;
